import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import SelectSearchSector from "@dropDesk/presentation/components/inputs/select_search_sectors";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputSectorSearch = observer(
    ({
         setFilterSector,
         filterSector,
         loading,
         hideLabel,
         size
     }: {
        setFilterSector: (filter: SectorEntity | null, withList?: boolean) => void,
        filterSector: SectorEntity | null
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <>
                {!appController.isUserClient &&
                    <Tooltip title={hideLabel ? 'Filtrar por setor' : undefined}>
                        <div style={{display: "flex", flex: 1}}>
                            <SelectSearchSector
                                size={size ?? 40}
                                useRemoveFilter={!!filterSector}
                                label={hideLabel ? undefined : 'Filtrar por Setor'}
                                placeHolder={"Pesquise por setor"}
                                handleSelectSector={(value, sector) => {
                                    setFilterSector(sector ?? null);
                                }}
                                value={filterSector ? {
                                    value: filterSector.id,
                                    label: filterSector?.realName(appController.user!)
                                } : undefined}
                                disabled={loading}
                                idUser={appController.user!.permissionAdmin ? undefined : appController.user!.id}
                                iconLeftName={ICONS_DROPDESK.sitemap}
                                borderColor={filterSector ? colors.accent : colors.border}
                            />
                        </div>
                    </Tooltip>
                }
            </>
        )
    })
export default InputSectorSearch;
